import React from "react";
import {
  Box,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AboutImage from "./images/AboutPage.jpg";

const AboutSection = () => {
  return (
    <Box
      sx={{
        background: "linear-gradient(to bottom, #ffffff, #e0e0e0 20%, #ffffff)",
        color: "#000",
        py: { xs: 6, md: 8 },
        px: { xs: 3, md: 6 },
      }}
    >
      <Box sx={{ maxWidth: "900px", mx: "auto", textAlign: "center", mb: 6 }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            mb: 3,
            lineHeight: 1.3,
            fontSize: {
              xs: "2.1rem",
              md: "3.3rem",
            },
          }}
        >
          Кто я:
        </Typography>

        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            mb: 2,
            fontSize: {
              xs: "1.25rem",
              md: "1.5rem",
            },
          }}
        >
          Меня зовут Владислав Кронин
        </Typography>
      </Box>
      <Grid container spacing={4} alignItems="center">
        {/* Фото */}
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={AboutImage}
            alt="Владислав Кронин"
            sx={{
              width: "100%",
              height: "auto",
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <List>
            <ListItem sx={{ alignItems: "flex-start" }}>
              <CheckCircleIcon sx={{ color: "#7e5f89", mr: 2 }} />
              <ListItemText primary="Я сертифицированный бизнес-коуч, практик НЛП для бизнеса и специалист по стратегическому управлению." />
            </ListItem>
            <ListItem sx={{ alignItems: "flex-start" }}>
              <CheckCircleIcon sx={{ color: "#7e5f89", mr: 2 }} />
              <ListItemText primary="Более 10 лет опыта в управлении компаниями из таких отраслей, как элитная недвижимость, логистика премиум-уровня и онлайн-маркетинг." />
            </ListItem>
            <ListItem sx={{ alignItems: "flex-start" }}>
              <CheckCircleIcon sx={{ color: "#7e5f89", mr: 2 }} />
              <ListItemText primary="Мой подход помог десяткам предпринимателей в Израиле и за рубежом:" />
            </ListItem>
            <List sx={{ pl: 4 }}>
              <ListItem>
                <ListItemIcon>
                  <FiberManualRecordIcon sx={{ color: "#7e5f89" }} />
                </ListItemIcon>
                <ListItemText primary="Увеличить доход." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <FiberManualRecordIcon sx={{ color: "#7e5f89" }} />
                </ListItemIcon>
                <ListItemText primary="Повысить продуктивность." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <FiberManualRecordIcon sx={{ color: "#7e5f89" }} />
                </ListItemIcon>
                <ListItemText primary="Создать успешные команды." />
              </ListItem>
            </List>
          </List>
        </Grid>
      </Grid>
      <Box sx={{ textAlign: "center", mt: 6 }}>
        <Typography
          variant="body1"
          sx={{ fontStyle: "italic", color: "000", maxWidth: "850px" }}
        >
          <Typography
            component="span"
            variant="body1"
            sx={{
              fontWeight: "bold",
            }}
          >
            Моя миссия
          </Typography>
          — помочь вам осознать сильные и слабые стороны вашего бизнеса,
          преодолеть внутренние и внешние барьеры и создать такую систему,
          которая будет работать на вас, принося стабильность и рост.
        </Typography>
      </Box>
    </Box>
  );
};

export default AboutSection;
